import { Injectable } from '@angular/core';
import { Http, L10n, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { FiscalDeviceRegistryQuery, FiscalDeviceRegistryQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(FiscalDeviceRegistryQuery)
@Wrapper(FiscalDeviceRegistryQueryHandlerBase)
export class FiscalDeviceRegistryQueryHandler {
    public constructor(
        http: Http,
        l10n: L10n
    ) { }
}
